module.exports = __webpack_public_path__ + "static/media/S1N7-2.3985c815.svg";